import { render, staticRenderFns } from "./No03.vue?vue&type=template&id=70022378&scoped=true"
import script from "./No03.vue?vue&type=script&lang=js"
export * from "./No03.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70022378",
  null
  
)

export default component.exports